import { AssetUrlPipe } from "../../../core/pipes/asset-url.pipe";
import { CommonModule } from "@angular/common";
import { Component, inject, Input } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { RestService } from "../../../core/services/rest.service";
import { ToasterService } from "../../../core/services/toaster-service";
import { MessageEnum } from "../../../core/utils/message.enum";
import { FileUploadComponent } from "../../common/file-upload/file-upload.component";
import { LoadingComponent } from "../../common/loading/loading.component";
import { NoDataComponent } from "../../common/no-data/no-data.component";

@Component({
  selector: "app-file-upload-modal",
  standalone: true,
  imports: [AssetUrlPipe,FileUploadComponent, CommonModule, FormsModule, NoDataComponent, LoadingComponent],
  templateUrl: "./file-upload-modal.component.html",
  styleUrl: "./file-upload-modal.component.scss",
})
export class FileUploadModalComponent {
  @Input()
  configs: any = [];

  @Input()
  releases: any = [];

  activeModal = inject(NgbActiveModal);
  selectedRelease: any;
  selectedReleaseLabel: any;
  isDisabled: boolean = true;
  selectedFile: any;
  fileData: any = [];
  isReleaseSelected: boolean = false;
  isLoading: boolean = false;
  selectedFileToDelete:any;
  isActive: boolean = false;

  constructor(private restService: RestService, private readonly toaster: ToasterService) {}
  // this.toaster.pop({ type: 'success', text: });
  ngOnInit() {
    // this.selectedRelease = this.releases.length > 0 ? this.releases[0].label : null;
    this.validateForm();
  }

  onSelectionChange() {
    this.selectedReleaseLabel = this.releases.find(
      (release: any) => release.value === this.selectedRelease
    )?.label;

    this.getUploadedFiles();
    this.validateForm();
  }

  getUploadedFiles() {
    this.isLoading = true;
    this.restService
      .getMannualUploadedFiles(this.configs?.projectId, this.selectedRelease)
      .subscribe({
        next: (response: any) => {
          this.isLoading = false;
          this.fileData = response?.data;
        },
        error: (error: any) => {
          this.isLoading = false;
          this.toaster.pop({ type: 'error', text: MessageEnum.ERROR_GETTING_UPLOADED_FILE })
        },
      });
  }

  rollBack(fileName: string) {
    this.selectedFileToDelete = fileName;
  }

  deleteFile(fileName: string){
    this.isLoading = true;
    this.restService
    .rollBackFile(this.configs?.projectId, this.selectedRelease, fileName)
    .subscribe({
      next: (response: any) => {
        this.isLoading = false;
        this.toaster.pop({ type: 'success', text: MessageEnum.ROLLBACK_UPLOADED_FILE_SUCCESS });
        this.selectedFileToDelete = "";
        this.getUploadedFiles();
      },
      error: (error: any) => {
        this.selectedFileToDelete = "";
        this.isLoading = false;
        this.toaster.pop({ type: 'error', text: MessageEnum.ROLLBACK_UPLOADED_FILE_FAILURE });
      },
    });
  }

  cancelDelete(){
    this.selectedFileToDelete = "";
  }

  handleFilesSelected(event: any) {
    console.log("selected file", event);
    this.selectedFile = event?.files[0];
    this.validateForm();
  }

  validateForm() {
    this.isDisabled = !(this.selectedRelease && this.selectedFile);
  }

  upload() {
    this.activeModal.close({
      value: {
        release: this.selectedRelease,
        file: this.selectedFile,
      },
    });
  }

  downloadTemplate() {
    this.restService.getSampleReportDownloadLink(this.configs?.projectId).subscribe((item: any) => {
      window.open(item?.data?.signedUrl, "_blank");
    });
  }

  deleteAllFiles() {
    if (!this.fileData || this.fileData.length === 0) {
      return;
    }

    this.fileData.forEach((file: any) => {
      if (file?.fileName) {
        this.deleteFile(file.fileName);
      }
    });
  }
}
